import { render } from "./m_brief.vue?vue&type=template&id=cc44dc7a&scoped=true"
import script from "./m_brief.vue?vue&type=script&lang=js"
export * from "./m_brief.vue?vue&type=script&lang=js"

import "./m_brief.vue?vue&type=style&index=0&id=cc44dc7a&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc44dc7a"]])

export default __exports__